import type { AlphaVariants } from '../utils'
import { getHexAlphaVariants } from '../utils'

export type ColorSchemes =
  | 'primary'
  | 'red'
  | 'blue'
  | 'green'
  | 'sky'
  | 'orange'

export type IPaletteColor = {
  base: string
  l1: string
  l2: string
  l3: string
  d1: string
  d2: string
}

export interface IPalette {
  primary: IPaletteColor
  red: IPaletteColor
  green: IPaletteColor
  blue: IPaletteColor
  sky: IPaletteColor
  orange: IPaletteColor
  grey: Omit<IPaletteColor, 'base'> & {
    l4: string
    d3: string
    d4: string
  }
}

export const palette: IPalette = {
  red: {
    base: '#c03030',
    l1: '#e28d8d',
    l2: '#f5d6d6',
    l3: '#faebeb',
    d1: '#a32929',
    d2: '#872222'
  },
  orange: {
    base: '#e68d09',
    l1: '#f9c576',
    l2: '#fdeace',
    l3: '#fef5e7',
    d1: '#c47908',
    d2: '#a26407'
  },
  green: {
    base: '#30c061',
    l1: '#8de2a9',
    l2: '#d6f5e0',
    l3: '#ebfaf0',
    d1: '#29a352',
    d2: '#228743'
  },
  sky: {
    base: '#0987e6',
    l1: '#76c0f9',
    l2: '#cee9fd',
    l3: '#e7f4fe',
    d1: '#0873c4',
    d2: '#075ea2'
  },
  blue: {
    base: '#0e09e6',
    l1: '#7876f9',
    l2: '#cfcefd',
    l3: '#e7e7fe',
    d1: '#0b08c4',
    d2: '#0907a2'
  },
  primary: {
    base: '#ac0ae8',
    l1: '#d676f9',
    l2: '#f0cefd',
    l3: '#f8e7fe',
    d1: '#9108c4',
    d2: '#7807a1'
  },
  grey: {
    l1: '#d8d8ee',
    l2: '#e2e2f3',
    l3: '#ededf7',
    l4: '#f8f8fc',
    d1: '#ababba',
    d2: '#73738c',
    d3: '#414158',
    d4: '#16161d'
  }
}

const alphas = getHexAlphaVariants({
  primary: palette.primary.base,
  black: palette.grey.d4,
  white: '#ffffff'
})

export interface IColors extends IPalette {
  white: string
  black: string
  whiteAlpha: AlphaVariants
  blackAlpha: AlphaVariants
  primaryAlpha: AlphaVariants
  interaction: string
  information: string
  success: string
  warning: string
  error: string
  disabled: {
    l1: string
    l2: string
  }
}

const colors: IColors = {
  ...palette,
  ...alphas,
  white: '#ffffff',
  black: palette.grey.d4,
  interaction: palette.primary.base,
  information: palette.sky.base,
  success: palette.green.base,
  warning: palette.orange.base,
  error: palette.red.base,
  disabled: {
    l1: '#f2f2f2',
    l2: '#b3b3b3'
  }
}

export default colors
